<template>
  <div class="PlansManagement">
    <div class="navbar">
      <NavBar></NavBar>
    </div>
    <div class="sideBarSection">
      <PlainSideBar v-if="isDesktop"></PlainSideBar>
    </div>

    <div v-if="isDesktop">
      <!-- v-if="user_details && user_details.is_active_ra" -->
      <div class="cover-page-container">
        <!-- Heading section -->
        <div class="flex-space-between user-details-section">
          <div class="label-lg-black-bold">
            <span class="crown-outer">
              <img src="../assets/images/Active RA - Crown Icon.svg" alt="" />
            </span>
            Plans Details
          </div>

          <div>
            <!-- <div style="height: 25px;">&nbsp;</div> -->
            <div
              class="flex"
              style="margin-top: 7px; align-items: baseline; justify-content: end;"
            >
              <el-button
                class="download-btn export-btn flex"
                style=""
                @click="getTotalEntriesForExport()"
                :disabled="!subscribedUsersList.length || is_export_Loading"
                :loading="is_export_Loading"
              >
                <span style="position: relative; top: -2px;">
                  Export
                  <i
                    class="el-icon-document"
                    style="font-size: 20px; margin-left: 3px; position: relative; top: 2px;"
                  ></i>
                </span>
              </el-button>
            </div>
          </div>
          <!-- <div>
               <img
                 src="../assets/images/RA-dashboard/Messenger active Icon.svg"
                 alt=""
               />
             </div> -->
        </div>

        <!-- Table filter section -->

        <div class="filter-section">
          <el-row :gutter="15" style="align-items: center;">
            <el-col :xs="24" :sm="2" :md="2" :lg="2" :xl="2">
              <!-- <div
                   class="label-xs-bold right-margin-15"
                   style="margin-top: 11px;"
                 >
                   Sort By:
                 </div> -->
            </el-col>
            <el-col :xs="24" :sm="22" :md="22" :lg="22" :xl="22">
              <div class="flex-space-between">
                <div class="flex">
                  <div>
                    <div class="input-label-bold-gray">
                      Filter By:
                    </div>
                    <div class="flex">
                      <el-input
                        v-model="searchQuery"
                        size="mini"
                        placeholder="Email, Mobile"
                        clearable
                        style="width: 200px; margin-right: 18px;"
                        @input="filterUserData()"
                      ></el-input>
                    </div>
                  </div>
                  <div>
                    <div class="input-label-bold-gray">
                      Past Duration:
                    </div>
                    <div class="flex">
                      <!-- <el-date-picker
                        v-model="selectedDateRange"
                        type="daterange"
                        unlink-panels
                        range-separator="To"
                        start-placeholder="From"
                        end-placeholder="To"
                        style="width: 230px"
                        size="mini"
                        class="custom-date-picker"
                        :picker-options="datePickerOptions"
                        @change="handleDateRangeChange"
                      ></el-date-picker> -->
                      <el-date-picker
                        v-model="startDate"
                        type="date"
                        placeholder="Start Date"
                        style="width: 130px; margin-right: 18px;"
                        size="mini"
                        class="custom-date-picker"
                        :default-value="defaultStartDate"
                        :picker-options="startDatePickerOptions"
                        @change="handleStartDateChange"
                      ></el-date-picker>
                      <el-date-picker
                        v-model="endDate"
                        type="date"
                        placeholder="End Date"
                        style="width: 130px; margin-right: 18px;"
                        size="mini"
                        class="custom-date-picker"
                        :default-value="defaultEndDate"
                        :picker-options="endDatePickerOptions"
                        @change="handleEndDateChange"
                      ></el-date-picker>
                    </div>
                  </div>

                  <div>
                    <div class="input-label-bold-gray">
                      Plan Status:
                    </div>
                    <div class="flex">
                      <el-select
                        v-model="status"
                        size="mini"
                        placeholder="Status"
                        style="width: 90px; margin-right: 18px;"
                        clearable
                        @change="filterUserData()"
                      >
                        <el-option
                          v-for="status in status_list"
                          :key="status.value"
                          :label="status.label"
                          :value="status.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>

                  <!-- <div>
                    <div class="input-label-bold-gray">
                      KYC Status:
                    </div>
                    <div class="flex">
                      <el-select
                        v-model="kycStatus"
                        size="mini"
                        placeholder="KYC Status"
                        clearable
                        style="width: 130px; margin-right: 18px;"
                        @change="filterUserData()"
                      >
                        <el-option
                          v-for="kyc in kyc_status_list"
                          :key="kyc"
                          :label="kyc"
                          :value="kyc"
                        ></el-option>
                      </el-select>
                    </div>
                  </div> -->

                  <div style="margin-top:30px;border-radius:10px; ">
                    <el-button
                      size="mini"
                      @click="clearFilters()"
                      style="border-radius: 10px;padding: 3px 10px;color:rgb(64, 158, 255);border-color:rgb(64, 158, 255);"
                      :disabled="isFilterActive() == false"
                    >
                      Reset
                    </el-button>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div
          v-if="subscribedUsersList.length || is_user_list_loading"
          v-loading="is_user_list_loading"
        >
          <div class="board-table-outer">
            <table class="outer-board-table board-table">
              <thead>
                <tr class="main-head">
                  <th style="min-width: 100px;">Name</th>
                  <th style="min-width: 50px;">Plan</th>
                  <th style="min-width: 50px;">Price</th>
                  <th style="min-width: 50px;">Validity</th>
                  <th style="min-width: 130px;">Plan Subscribed On</th>
                  <th style="min-width: 130px;">Plan Expired On</th>
                  <!-- <th style="min-width: 50px;">Status</th> -->
                  <!-- <th>
                    Invoice
                 <span
                         ><i
                           class="el-icon-download"
                           style="font-size: 16px;
                                   color: #4488d0;
                                   position: relative;
                                   top: 2px;
                                   font-weight: 600; "
                           @click="downloadBulkDetailsPdf()"
                         ></i
                       ></span> 
                  </th> -->
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in subscribedUsersList"
                  :key="index"
                  @contextmenu.prevent="showContextMenu($event, data)"
                >
                  <td>{{ data.full_name ? data.full_name : "--" }}</td>
                  <td>{{ data.plan_name ? data.plan_name : "--" }}</td>
                  <td>{{ data.amount ? data.amount : "--" }}</td>
                  <td>{{ data.days ? data.days : "--" }}</td>

                  <td>
                    {{ moment(data.start_at).format("MMM DD YYYY, h:mmA") }}
                  </td>
                  <td>
                    {{ moment(data.expire_at).format("MMM DD YYYY, h:mmA") }}
                  </td>
                  <!-- <td
                      class="live"
                      :class="data.plan_status == 'Live' ? 'live' : 'expired'"
                    >
                      {{ data.plan_status }}
                    </td> -->
                  <!-- <td class="text-center">
                       <i
                         class="el-icon-bottom font-weight-700 download-btn"
                         style="font-size: 13px;"
                         @click="downloadPdf(data.invoice_url)"
                       ></i>
                     </td> -->
                  <!-- <td>
                    <div
                      v-if="data.plan_name !== 'Lite'"
                      @click="downloadInvoiceAdmin(data.id)"
                      class="external-link-color"
                      style="cursor: pointer;"
                    >
                      <i
                        class="el-icon-download"
                        style="font-size: 16px; font-weight:700; color: #4488d0;"
                      ></i>
                    </div>
                    <div v-else>
                      <i
                        class="el-icon-download"
                        style="font-size: 16px; color: #4488d0; opacity: 0.5; cursor: not-allowed;"
                      ></i>
                    </div>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Context Menu -->
          <div
            v-if="contextMenuVisible"
            class="context-menu"
            :style="{ top: `${contextMenuY}px`, left: `${contextMenuX}px` }"
          >
            <ul>
              <li
                :class="{ inactive: contextMenuData.plan_name === 'Lite' }"
                @click="
                  contextMenuData.plan_name !== 'Lite' &&
                    downloadInvoiceAdmin(contextMenuData.id)
                "
              >
                Download Invoice
              </li>
            </ul>
          </div>
          <div class="pagination" style="text-align:center">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="pagination.current_page"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pagination.page_size"
              :total="pagination.total_entries"
              :pager-count="5"
              layout="total, prev, pager, next"
            ></el-pagination>
          </div>
        </div>
        <div v-if="!is_user_list_loading && !subscribedUsersList.length">
          <NoDataFound></NoDataFound>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="cover-page-container">
        <div class="block-mob-view">
          To access the Dashboard Analytics, please log in via desktop for an
          enhanced user experience.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var echarts = require("echarts");
import { serverAddr, serverHostName, serverAddrForCSV } from "../networkConfig";
import { filterCallBack } from "../mixins/filter";
import PlainSideBar from "@/components/PlainSideBar.vue";
import Hexagon from "@/components/Hexagon.vue";
import { screenSize } from "../mixins/ScreenSize.js";
import { required } from "vuelidate/lib/validators";
import CripNotice from "crip-vue-notice";
import { HelperNetworkCallBack } from "../mixins/Helper";
import moment from "moment";
import NoDataFound from "@/components/NoDataFound.vue";
import NavBar from "@/components/NavBar.vue";
import ExcelJS from "exceljs";

export default {
  name: "PlansManagement",

  mixins: [filterCallBack, screenSize, HelperNetworkCallBack],

  components: {
    PlainSideBar,
    Hexagon,
    NavBar,
    NoDataFound,
  },

  data() {
    return {
      nav_title: "Expert's Analytics",
      serverHostName: serverHostName,
      moment: moment,
      pickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value1: "",
      value2: "",
      subscribedUsersList: [],

      status_list: [
        { label: "Live", value: "Live" },
        { label: "Expired", value: "Expired" },
      ],
      status: "",
      pagination: [],
      currentPage: 1,
      selectedDateRange: [],
      startDate: "", // no preselected date
      endDate: "", // no preselected date
      defaultStartDate: new Date(
        new Date().setMonth(new Date().getMonth() - 1)
      ), // default view of the previous month
      defaultEndDate: new Date(), // default view of the current month,
      active_period: "1M",
      period_list: [
        {
          label: "1 Month",
          value: "1M",
        },
        {
          label: "3 Month",
          value: "3M",
        },
        {
          label: "6 Month",
          value: "6M",
        },
        {
          label: "1 Year",
          value: "1Y",
        },
      ],
      kycStatus: "",
      kyc_status_list: ["KYC Verified", "KYC Not Verified"],
      is_user_list_loading: false,
      is_export_Loading: false,
      exportUserList: [],
      selectedEmail: "",
      searchQuery: "",
      userId: this.$route.params.userId,
      selected_broker_id: null,
      user_id: null,
      profile_id: "",
      plan_id: "",

      contextMenuVisible: false,
      contextMenuX: 0,
      contextMenuY: 0,
      contextMenuData: null,
    };
  },

  validations: {
    // review_title: {
    //     required
    // },
    review: {
      required,
    },
  },

  mounted() {
    // Call getSubscribedUsersList initially if selected_broker is already set
    if (this.selected_broker && !this.$route.query.user_id) {
      this.getSubscribedUsersList();
    }
    if (this.$route.query.user_id && this.selected_broker) {
      this.user_id = this.$route.query.user_id;
      console.log(this.user_id);
      this.getSubscribedUsersList();
    }
  },
  watch: {
    // selected_broker(newValue, oldValue) {
    //   if (newValue) {
    //     // clearFilters and get all data
    //     this.clearFilters();
    //   }
    // },

    // elected_broker(newBroker, oldBroker) {
    //   if (newBroker && newBroker.id !== oldBroker?.id) {
    //   }s
    // },
    selected_broker(newBroker, oldBroker) {
      if (newBroker && (!oldBroker || newBroker.id !== oldBroker.id)) {
        this.clearFilters();
      }
    },
    user_details(newValue, oldValue) {
      if (
        newValue &&
        newValue.mark_as_verified &&
        newValue.is_active_ra &&
        this.isDesktop
      ) {
        this.getSubscribedUsersList();
      }
    },
    selectedDateRange() {
      this.filterUserData(); // Fetch data when date range changes
    },
    startDate(newValue, oldValue) {
      if (newValue) {
        this.startDate = this.formatDate(newValue);
      }
      if (newValue == null) {
        this.startDate = "";
      }
    },
    endDate(newValue, oldValue) {
      if (newValue) {
        this.endDate = this.formatDate(newValue);
      }
      if (newValue == null) {
        this.endDate = "";
      }
    },
  },

  methods: {
    showContextMenu(event, data) {
      this.contextMenuVisible = true;
      this.contextMenuX = event.clientX;
      this.contextMenuY = event.clientY;
      this.contextMenuData = data;
      document.addEventListener("click", this.closeContextMenu);
    },
    closeContextMenu() {
      this.contextMenuVisible = false;
      document.removeEventListener("click", this.closeContextMenu);
    },
    downloadInvoiceAdmin(plan_id) {
      var pdfUrl = `${
        this.serverHostName
      }/api/auth/admin/v1/download_invoice_admin_panel?plan_id=${plan_id}`;
      window.open(pdfUrl, "_blank");
    },
    handleStartDateChange(val) {
      if (this.endDate && new Date(val) > new Date(this.endDate)) {
        this.endDate = val;
      }
      if (this.startDate && this.endDate) {
        this.getSubscribedUsersList();
      }
    },
    handleEndDateChange(val) {
      if (
        val != null &&
        this.startDate &&
        new Date(val) < new Date(this.startDate)
      ) {
        this.startDate = val;
      }
      if (this.startDate && this.endDate) {
        this.getSubscribedUsersList();
      }
    },
    downloadBulkDetailsPdf() {
      var linkForDownload = `${
        this.serverHostName
      }/api/my_dashboard/v1/sa/download_invoice_SA_Dashboard?`;
      linkForDownload = this.status.length
        ? linkForDownload + "status=" + this.status
        : linkForDownload;
      linkForDownload = this.startDate
        ? linkForDownload + "&start_date=" + this.startDate
        : linkForDownload;
      linkForDownload = this.endDate
        ? linkForDownload + "&end_date=" + this.endDate
        : linkForDownload;

      linkForDownload = this.kycStatus.length
        ? linkForDownload + "&kyc_status=" + this.kycStatus
        : linkForDownload;

      linkForDownload = this.selected_broker
        ? linkForDownload + "&broker=" + this.selected_broker.id
        : linkForDownload;

      window.open(linkForDownload, "_blank");
    },
    openWhatsApp(mobile) {
      if (mobile != null) {
        var whatsappURL;
        if (window.innerWidth < 992) {
          // Construct the WhatsApp URL
          whatsappURL = `https://wa.me/${mobile}`;
        } else {
          whatsappURL = `https://web.whatsapp.com/send?phone=${mobile}`;
        }

        // Open the WhatsApp URL
        var newWindow = window.open(whatsappURL, "_blank");

        // Check if a new tab was opened
        if (
          !newWindow ||
          newWindow.closed ||
          typeof newWindow.closed == "undefined"
        ) {
          // If the window was blocked or closed, prompt the user to check their browser settings
          alert(
            "WhatsApp window was blocked or closed. Please check your browser settings to allow pop-ups or manage tabs."
          );
        }
      } else {
        new CripNotice({
          title: "Oops! Something went wrong!",
          description: "Mobile number not present",
          type: "error",
          duration: 3,
        });
      }
    },
    async checkLoginUserDetail() {
      const computedValue = this.user_details;
      if (
        computedValue &&
        computedValue.mark_as_verified &&
        computedValue.is_active_ra
      ) {
        this.getSubscribedUsersList();
      }
    },

    formatDate(date) {
      return date ? moment(date).format("YYYY-MM-DD") : "";
    },

    filterUserData() {
      this.currentPage = 1;
      this.getSubscribedUsersList();
    },

    disableFutureDates(date) {
      return date.getTime() > Date.now();
    },

    handleDateRangeChange(value) {
      this.selectedDateRange = value;
    },

    handleEmailClick(email) {
      this.selectedEmail = email;
      this.filterUserData();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.getSubscribedUsersList();
    },

    downloadPdf(path) {
      window.open(`${this.serverHostName + "/" + path}`, "_blank");
    },

    async downloadExcel() {
      try {
        // Fields to remove
        const fieldsToRemove = ["plan_name", "invoice_url"];

        // Remove specified fields from each object in the array
        const newData = this.exportUserList.map((obj) => {
          const newObj = { ...obj }; // Create a shallow copy of the original object
          fieldsToRemove.forEach((field) => {
            delete newObj[field];
          });
          return newObj;
        });

        const data = newData;
        // Create a new workbook
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Sheet1");

        // Add headers
        const headers = Object.keys(data[0]);
        worksheet.addRow(headers);

        // Add data to worksheet
        data.forEach((item) => {
          const rowValues = headers.map((header) => item[header]);
          worksheet.addRow(rowValues);
        });

        // Set column widths
        ["A", "B", "D", "G", "K"].forEach((column) => {
          worksheet.getColumn(column).width = 18; // Example width
        });

        ["C", "H", "I", "L", "M"].forEach((column) => {
          worksheet.getColumn(column).width = 28; // Example width
        });

        ["D", "E", "F", "J", "N"].forEach((column) => {
          worksheet.getColumn(column).width = 14; // Example width
        });

        // Generate Excel file
        const buffer = await workbook.xlsx.writeBuffer();

        // Create Blob
        const blob = new Blob([buffer], { type: "application/octet-stream" });

        // Create download link
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "StockAnts User Subscription List.xlsx";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error exporting to Excel:", error);
      }
      setTimeout(() => {
        this.is_export_Loading = false;
      }, 100);
    },

    getBrokerList() {
      serverAddr
        .get("/auth/admin/v1/client_list")
        .then((response) => {
          if (response.data.status) {
            this.brokerList = response.data.data;
          }
        })
        .catch(
          function(error) {
            console.log(error);
            this.is_user_list_loading = false;
          }.bind(this)
        );
    },

    removeQueryParam() {
      // Access the current query parameters
      let queryParams = { ...this.$route.query };

      // Remove the 'user_id' query parameter
      delete queryParams.user_id;

      // Update the URL without the query parameter
      this.$router.push({ query: queryParams });
    },

    clearFilters() {
      this.selectedDateRange = [];
      this.startDate = "";
      this.endDate = "";
      this.status = "";
      this.kycStatus = "";
      // this.$store.commit("commitSelectedBroker", null);
      this.currentPage = 1;
      this.selectedEmail = "";
      this.searchQuery = "";
      this.user_id = "";
      this.removeQueryParam();
      this.filterUserData();
    },
    isFilterActive() {
      if (
        (this.startDate && this.startDate.length) ||
        (this.endDate && this.endDate.length) ||
        this.status.length ||
        this.selectedEmail.length ||
        this.kycStatus.length ||
        this.searchQuery.length
      ) {
        return true;
      } else {
        return false;
      }
    },

    getSubscribedUsersList() {
      this.selected_broker_id = this.selected_broker
        ? this.selected_broker.id
        : null;
      if (this.selected_broker_id != null) {
        this.is_user_list_loading = true;

        // send query parameters
        var queryParams = new URLSearchParams({
          client_id: this.selected_broker_id,
          start_date: this.startDate,
          end_date: this.endDate,
          kyc_status: this.kycStatus,
          page_no: this.currentPage,
          page_per_entries: 10,
          status: this.status == "All" ? "" : this.status,
          q: this.searchQuery,
        });

        if (this.user_id) {
          queryParams.append("user_id", this.user_id);
        }

        serverAddr
          .get(`/auth/admin/v1/plan_details?${queryParams}`)
          .then((response) => {
            if (response.data.status) {
              this.subscribedUsersList = response.data.data;
              this.pagination = response.data.pagination;
            } else {
            }
            setTimeout(() => {
              this.is_user_list_loading = false;
            }, 100);
          })
          .catch(
            function(error) {
              console.log(error);
              this.is_user_list_loading = false;
            }.bind(this)
          );
      }
    },

    async getTotalEntriesForExport() {
      this.is_export_Loading = true;

      // send query parameters
      var queryParams = new URLSearchParams({
        client_id: this.selected_broker ? this.selected_broker.id : 0,
        start_date: this.startDate,
        end_date: this.endDate,
        kyc_status: this.kycStatus,
        status: this.status == "All" ? "" : this.status,
        page_no: 1,
        page_per_entries: this.pagination.total_entries, // Fetch all entries for export
        q: this.searchQuery,
      }).toString();

      try {
        const response = await serverAddr.get(
          `/auth/admin/v1/plan_details?${queryParams}`
        );
        if (response.data.status) {
          this.exportUserList = response.data.data;
          this.downloadExcel();
        } else {
          this.is_export_Loading = false;
          console.error("Failed to fetch user data for export");
        }
      } catch (error) {
        console.error("Error fetching user data for export:", error);
        this.is_export_Loading = false;
      }
    },

    downloadInvoices() {
      var obj = {};
      obj.page_no = 1;
      obj.page_per_entries = this.pagination.total_entries;
      obj.status = this.status == "All" ? "" : this.status;
      obj.start_date = this.startDate;
      obj.end_date = this.endDate;
      obj.kyc_status = this.kycStatus;
      obj.is_export = false;
      obj.email_id = this.selectedEmail;

      serverAddr
        .post("/my_dashboard/v1/sa/download_invoice_for_SA_Dashboard", obj)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "bulk_invoice.pdf");
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  computed: {
    startDatePickerOptions() {
      return {
        disabledDate: (time) => {
          const now = new Date();
          if (this.endDate) {
            return (
              time.getTime() > now.getTime() ||
              time.getTime() > new Date(this.endDate).getTime()
            );
          }
          return time.getTime() > now.getTime();
        },
      };
    },
    endDatePickerOptions() {
      return {
        disabledDate: (time) => {
          const now = new Date();
          if (this.startDate) {
            return (
              time.getTime() < new Date(this.startDate).getTime() ||
              time.getTime() > now.getTime()
            );
          }
          return time.getTime() > now.getTime();
        },
      };
    },
    selected_broker() {
      return this.$store.state.selected_broker
        ? this.$store.state.selected_broker
        : null;
    },

    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },

    // return user details e.g. accuracy, success rate, rating etc.
    user_details() {
      return this.$store.state.user_details;
    },

    //returns subscribed plan details from local storage
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem("plan_details"));
    },

    datePickerOptions() {
      return {
        disabledDate: (date) => {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return date.getTime() > today.getTime();
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.PlansManagement {
  min-height: calc(100vh - 60px);
  background-color: $page-background-color;
  padding: 60px 0 0 0;

  .block-mob-view {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    color: $secondary-theme-color;
    font-weight: 600;
    padding: 20px;
    text-align: center;
  }
  .outer {
    background-color: #feffe5;
    text-align: center;
    padding: 10px 0px 20px;
    width: calc(100% - 265px);
    margin-left: 265px;
  }
  .marquee-container img {
    max-height: 35px;
    margin-right: 60px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  // Below css for Marquee tag
  marquee {
    height: 100px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    box-sizing: border-box;
    padding-top: 10px;
    padding-bottom: 10px;
    justify-content: center;
  }

  @keyframes marquee {
    0% {
      transform: translateX(100%);
    }

    100% {
      transform: translateX(-100%);
    }
  }
  .cover-page-container {
    .export-btn {
      font-size: 12px;
      padding: 4px 10px;
      margin-left: 8px;
    }
    .board-table-outer {
      border-top: 4px solid #bea66e;
      overflow-x: auto;
      min-height: 370px;

      .live {
        color: #079e3e;
      }

      .expired {
        color: #e72726;
      }
      .download-btn {
        padding: 5px 8px;
        font-size: 12px;
        width: 15px;
        margin: 0 auto;
        box-shadow: 0px 1px 3px 1px #e0e0e0;
      }
      .sub-section {
        padding: 0 !important;
      }
      .sub-sec-head {
        width: 100%;
        text-align: left;
        background-color: #2d2e8d;
        padding: 10px;
        color: #ffff;
        margin: 10px 0 0;
        font-weight: 600;
      }
    }

    .center-content {
      text-align: center;
      vertical-align: middle;
    }

    .loader-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 0.8);
      z-index: 10;
    }

    .board-table {
      overflow-x: auto;
      border-spacing: 0;
      border-collapse: collapse;
      width: 100%;
      text-align: left;

      .main-head th {
        color: #000;
      }

      .border-right-gray {
        border-right: 1px solid #e9e9e9;
      }
      .border-bottom-gray {
        border-bottom: 1px solid #e9e9e9;
      }
      .bottom-spacing-table-heading {
        padding: 0px 8px 8px 8px;
      }
      thead {
        tr {
          th {
            color: #a5a6a8;
            font-size: 0.8rem;
            font-weight: 700;
            padding: 10px 15px;
            white-space: nowrap;
          }
        }

        tr:nth-child(1) {
          border-bottom: 1px solid #e9e9e9;
          background-color: #ededed;
        }
      }
      tbody {
        // min-height: 300px;
        tr {
        //  cursor: pointer;
          td {
            font-size: 0.7rem;
            font-weight: 500;
            padding: 10px 15px;
            // vertical-align: unset;
          }
        }
        // tr:hover {
        //   background-color: #eff5fe;
        // }

        tr:nth-child(even) td {
          background-color: #f1f7f8; /* Set background color for even rows */
        }
      }
      td.fixed-column,
      th.fixed-column {
        position: sticky;
        right: -1px; /* Fix column to the right */
        z-index: 1;
        background-color: #ffff;
        border-bottom: none;
        height: 23px;
        border-left: 1px solid #dcdcdc !important;
        box-shadow: -4px 1px 5px -3px #00000080;
        margin: 0;
        padding: 12px 8px;
      }
    }

    .el-range-editor.el-input__inner {
      margin-right: 20px;
    }
    .pagination {
      margin: 15px 0 10px;
    }
    .user-details-section {
      border-bottom: 1px solid #d5d5d5;
      padding: 10px 20px;
    }

    .crown-outer {
      background: #bea66e;
      padding: 2px 5px;
      border-radius: 5px;
      margin-right: 3px;
    }
    .filter-section {
      padding: 0 20px;
      margin-bottom: 15px;
    }
  }
  .cover-page-container {
    width: calc(100% - 295px);
    margin-left: 280px;
    margin-top: 15px;
    padding-bottom: 10px;
    // padding: 20px 0;
    box-sizing: border-box;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0px 0px 7px 1px #dcd6d6;
    margin-bottom: 50px;
  }

  .footer-section {
    width: calc(100% - 260px);
    margin-left: 260px;
  }

  @media screen and (max-width: 1283px) {
    .cover-page-container,
    .footer-section {
      width: 100%;
      margin-left: 0;
      height: calc(100vh - 160px);
      margin-top: 15px;
    }
    .cover-page-container {
      //   padding: 20px 10px 0 10px;
    }
    .sideBarSection {
      display: none;
    }
  }
}
</style>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.PlansManagement {
  .NoDataFound {
    padding: 15px 0 0 0;
  }
  .review-card {
    border-radius: 10px;
    .el-card__body {
      padding: 5px 20px;
    }
  }
  .analytics-card {
    border-radius: 10px;
  }

  .review-section,
  .user-access-section {
    .el-rate__icon {
      font-size: 14px !important;
      margin-right: 2px;
    }
  }

  .referal-dialog {
    .el-dialog__header .el-dialog__title {
      color: #000;
      font-weight: 500;
    }
  }

  @media screen and (max-width: 992px) {
    .referal-dialog {
      width: 80% !important;
    }
  }
}
.context-menu {
  position: absolute;
  z-index: 1000;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.context-menu ul {
  list-style: none;
  padding: 0;
  margin: 5;
}

.context-menu li {
  padding: 8px 12px;
  cursor: pointer;
}

.context-menu li:hover {
  background-color: #f5f5f5;
}

.context-menu li.inactive {
  color: #ccc;
  cursor: not-allowed;
}
</style>
